import styled from 'styled-components';
import { Note } from '@annote/types';
import { ReactComponent as AIIcon } from 'src/components/Icon/icons/ai.svg';
import { ReactComponent as DotsIcon } from 'src/components/Icon/icons/dots.svg';
import { useState } from 'react';

import { colors } from '@annote/core/styles';
import CardExtrasMenu from './CardExtrasMenu';
import AIMenu from './AIMenu';
import { CardMenuButton } from './CardButton';
import { OpenInPanelButton } from './OpenInPanelButton';
import { SuggestionButtons } from './SuggestionButtons';

const MenuButtonWrapper = styled.div<{ hasOpenMenu: boolean; isSuggestion: boolean }>`
  position: absolute;
  top: 8px;
  right: 8px;
  transition: opacity 0.2s ease;
  z-index: 2;
  background-color: inherit;
  border-radius: 4px;
  box-shadow: ${colors.shadow.toolbar};

  ${({ hasOpenMenu, isSuggestion }) => {
    const opacity = hasOpenMenu || isSuggestion ? 1 : 0;
    return `
    opacity: ${opacity};
  `;
  }}

  .card:hover & {
    opacity: 1;
  }
`;

type OpenMenu = 'ai' | 'extras' | null;

export const CardButtonsBar: React.FC<{ note: Note }> = ({ note }) => {
  const [openMenu, setOpenMenu] = useState<OpenMenu>(null);

  return (
    <MenuButtonWrapper hasOpenMenu={openMenu !== null} isSuggestion={!!note.suggestionId}>
      {note.suggestionId ? (
        <SuggestionButtons note={note} />
      ) : (
        <>
          <OpenInPanelButton note={note} />

          <CardMenuButton
            iconSVG={AIIcon}
            isOpen={openMenu === 'ai'}
            onToggle={() => setOpenMenu(openMenu === 'ai' ? null : 'ai')}
          >
            <AIMenu note={note} />
          </CardMenuButton>

          <CardMenuButton
            iconSVG={DotsIcon}
            isOpen={openMenu === 'extras'}
            onToggle={() => setOpenMenu(openMenu === 'extras' ? null : 'extras')}
          >
            <CardExtrasMenu note={note} />
          </CardMenuButton>
        </>
      )}
    </MenuButtonWrapper>
  );
};
